import { render, staticRenderFns } from "./FloatingChat.vue?vue&type=template&id=73e9644c&scoped=true"
import script from "./FloatingChat.vue?vue&type=script&lang=js"
export * from "./FloatingChat.vue?vue&type=script&lang=js"
import style0 from "./FloatingChat.vue?vue&type=style&index=0&id=73e9644c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e9644c",
  null
  
)

export default component.exports